import { getDefaultTeamColor } from '@this+that/constants';
import { extractInitials } from '@this+that/utils';

interface TeamMonogramProps {
  name: string;
  color?: string;
  size?: number;
}

const MONOGRAM_DEFAULT_SIZE = 46;
const MONOGRAM_RADIUS_RATIO = 0.28;
const MONOGRAM_FONT_RATIO = 0.36;

const stylesheet = {
  wrapper:
    'flex-shrink-0 grid place-items-center select-none font-extrabold text-semantic-emerald-fg',
};

export function TeamMonogram({
  name,
  color,
  size = MONOGRAM_DEFAULT_SIZE,
}: Readonly<TeamMonogramProps>) {
  const bgColor = color ?? getDefaultTeamColor(name);

  return (
    <div
      className={stylesheet.wrapper}
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * MONOGRAM_RADIUS_RATIO),
        backgroundColor: bgColor,
        fontSize: Math.round(size * MONOGRAM_FONT_RATIO),
        fontWeight: 800,
        letterSpacing: '-0.02em',
      }}
      aria-label={name}
    >
      {extractInitials(name)}
    </div>
  );
}
